import axios from "axios";
import messages from "@/messages";
import env from "@/env";

export const getJWT = () => {
  return window.localStorage.getItem("JWT") || false;
};

export const setJWT = (jwt) => {
  return window.localStorage.setItem("JWT", jwt);
};

export default {
  install: function (app) {
    const $http = async function ({
      auth = true, // Choose to send bearer if available
      loader = true, // Show loading spinner
      notifyErrors = false,
      baseUrl = env.baseUrl,
      url = "",
      headers = {},
      ...config
    } = {}) {
      const base = {};

      const requestHeaders = {
        "X-APP-VERSION": env.appVersion,
        ...headers,
      };

      if (auth) {
        const jwt = getJWT();
        if (jwt) {
          requestHeaders.Authorization = `Bearer ${jwt}`;
        }
      }

      base.headers = requestHeaders;

      if (loader) await this.$loading.show();

      let data;

      try {
        data = await axios({
          ...base,
          ...config,
          url: `${baseUrl}${url}`,
        });

        if (data.data && data.data.jwt) setJWT(data.data.jwt);
      } catch (e) {
        if (e.request && e.request.status === 401) {
          this.$store.dispatch("logout");
          this.$toast({
            message: messages.errors.loginNecessary,
            color: "danger",
          });
          if (loader) await this.$loading.hide();
          // FIXME: pay attention, it is possible to break stuff by returning an object
          return {};
        }

        if (loader) await this.$loading.hide();
        if (notifyErrors) {
          this.$toast({
            message: messages.errors.cannotPerform,
            color: "error",
          });
          return console.error(e);
        }
        throw e;
      }
      await this.$loading.hide();
      return data.data;
    };

    app.config.globalProperties.$http = $http;
  },
};
